<template>
<!--         :onOpenPanel="openWorksAndSheetsPanel()" doesnt work, needed to comment out because of infinity loop -->
<BasePanel 
        headline="lang_PUBLISHING_WORKS_SHEETS_AND_PROJECTS_PANEL_CAPTION_SHEETS_AND_PROJECTS"
        :alvqa="alvqa"
    >
    <template v-slot:panelContent>
        <v-data-table         
                :headers="headers"
                hide-default-footer
                :items="item"
                item-key="index"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                :page.sync="currentPage"
                class="noMinWidth"
                :items-per-page="itemsPerPage"
                :loading-text="$t('lang_GENERAL_LOADING_DATATABLE')"
                :loading="isLoading"
                :server-items-length="totalRecords"
            >
        <!-- alvqas for headers -->
            <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
            </template>

            <template v-slot:[`item.title`]="{ item }">
                <div :alvqa="alvqa +'-text-title'">
                    {{ item.title }}
                </div>
            </template>

            <template v-slot:[`item.sheetNumber`]="{ item }">
                <div :alvqa="alvqa +'-text-sheet-number'">
                    {{ item.sheetNumber }}
                </div>
            </template>

            <template v-slot:[`item.workSheetSeconds`]="{ item }">
                <div :alvqa="alvqa +'-text-seconds'">
                    {{ item.workSheetSeconds !== null ? $alvPlugin.transformSecondsToDuration(item.workSheetSeconds) + ' (' + (item.workSheetSeconds) + ')' : '' }}
                </div>
            </template>

            <template v-slot:[`item.workCharacteristic`]="{ item }">
                <div :alvqa="alvqa +'-text-characteristic'">
                    {{ getCharacteristicType(item.workCharacteristic)  }}
                </div>
            </template>

            <template v-slot:[`item.projectTitle`]="{ item }">
                <div :alvqa="alvqa +'-text-project-title'">
                    {{ item.projectTitle }}
                </div>
            </template>
        
        </v-data-table>

        <v-pagination   
            v-if="numberOfPages > 1"
            total-visible="10" 
            v-model="currentPage" 
            :length="numberOfPages"
            color="pagination"
            @input.stop="nextPage()"
        ></v-pagination>

    </template>

</BasePanel>


</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import { 
        DropdownPublishingSheetsWorkCharacteristicType
    } 
from '@/assets/dropdowns/alvDropdowns.js'

export default {

    name:"WorkSheetsAndProjectsPanel",
    components:{    
        BasePanel
    },  
    props:{
        workAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'publishing-works-list-row-' + this.workAlvId + '-read-only-panel-sheets-and-projects'
        }
    },

    computed: {
        item() { return this.$store.getters.getWorksSheetsAndProjects },
        headers() {
            return [
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_TITLE'), 
                    align: "left", 
                    value: "title",
                    sortable: false,
                    alvqa: this.alvqa + '-header-title'
                },
                {
                    text: this.$t("lang_PUBLISHING_SHEETS_CAPTION_SHEET_NUMBER"), 
                    align: "left", 
                    value: "sheetNumber",
                    sortable: false,
                    alvqa: this.alvqa + '-header-sheet-number'
                },
                {
                    text: this.$t("lang_PUBLISHING_SHEETS_CAPTION_SECONDS"), 
                    align: "left", 
                    value: "workSheetSeconds",
                    sortable: false,
                    alvqa: this.alvqa + '-header-work-seconds'
                },
                {
                    text: this.$t("lang_PUBLISHING_SHEETS_CAPTION_CHARACTERISTIC"), 
                    align: "left", 
                    value: "workCharacteristic",
                    sortable: false,
                    alvqa: this.alvqa + '-header-characteristic'
                },
                {
                    text: this.$t("lang_PUBLISHING_PROJECTS_CAPTION_TITLE"), 
                    align: "left", 
                    value: "projectTitle",
                    sortable: false,
                    alvqa: this.alvqa + '-header-project-title'
                },
            ]
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
        isLoading() { return this.$store.getters.getIsLoading },

        // Paging
        currentPage: {
            get() { return this.$store.getters.getWorksSheetsAndProjectsCurrentPage },
            set(page) { this.$store.commit('setWorksSheetsAndProjectsCurrentPage', page)}
        },
        totalRecords() { return this.$store.getters.getWorksSheetsAndProjectsTotalRecords },
        numberOfPages() { return this.$store.getters.getWorksSheetsAndProjectsNumberOfPages },

    },
    methods:{
        // openWorksAndSheetsPanel(){
        //     this.$store.dispatch("fetchWorksProjectsSheets")
        // },

        getCharacteristicType(characteristicType){
            if(characteristicType !== null){
                let match = DropdownPublishingSheetsWorkCharacteristicType.find(element => {
                    return element.value === characteristicType
                })
                    if(match !== undefined){
                        return this.$t(match.text)
                    }else{
                        return ""
                    }
            }else{
                return ""
            }
        },

        async nextPage() {
            await this.$store.dispatch('fetchWorksProjectsSheets')
        },
    }

}
</script>

<style>
.noMinWidth table {
        min-width: 0px !important;
    }

</style>